import { connect } from 'react-redux';
import { setConfig } from 'react-key-layers';
import {
  selectors,
  operations as creators,
} from '../../../store/conversations';
import {
  selectors as notificationSelectors,
  operations as notificationOperations,
} from '../../../store/notifications';
import { operations as reactionOperations } from '../../../store/reactions';
import {
  bbbEnabled,
  bbbEnabledInConversations,
} from '../../../../core/selectors/institution';

import ConversationModal from './ConversationModal';
import { config as modalLayersConfig } from './modalLayersConfig';

setConfig(modalLayersConfig);

const groupIdFromLocation = (location) => location.query.inbox;

const makeMapStateToProps = () => {
  return (state, ownProps) => {
    const isFetchingGroups = false;
    const groupId = groupIdFromLocation(ownProps.location);
    const { conversations } = state.data.inboxv2;
    const conversation = conversations[groupId];

    const currentUser = state.user.user;

    return {
      groupId,
      currentUser,
      conversation,
      leaveGroupOpened: state.inboxv2.leaveGroupOpened,
      leavingConversation: state.inboxv2.leavingConversation,
      open: !!groupId && !isFetchingGroups,
      renameGroupOpened: state.inboxv2.renameGroupOpened,
      title: selectors.conversationTitle(state, groupId),
      isBBBEnabled: bbbEnabled(state) && bbbEnabledInConversations(state),
      conversationMuted: notificationSelectors.isConversationMuted(
        state,
        groupId
      ),
    };
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  openAddParticipant: () => dispatch(creators.openViewParticipants(true)),
  closeLeaveGroup: () => dispatch(creators.closeLeaveGroup()),
  openLeaveGroup: () => dispatch(creators.openLeaveGroup()),
  openRenameGroup: () => dispatch(creators.openRenameGroup()),
  openViewParticipants: () => dispatch(creators.openViewParticipants()),
  leaveConversation: () => dispatch(creators.leaveConversation()),
  toggleReaction: ({ itemId, emojiName }) =>
    dispatch(
      reactionOperations.toggleReaction({
        itemId,
        itemType: 'UBInboxMessage',
        emojiName,
      })
    ),
  fetchMessages: () => dispatch(creators.fetchMessages({ replace: true })),
  toggleMuteConversation: () => {
    const conversationId = groupIdFromLocation(ownProps.location);
    return dispatch(
      notificationOperations.toggleMuteConversation(conversationId)
    );
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  leaveConversation: async () => {
    await dispatchProps.leaveConversation();
    dispatchProps.closeLeaveGroup();
    ownProps.closeModal();
  },
});

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ConversationModal);
